module.exports = ["Fantasy and Supernatural","Politics","War and Action","History and Mythology","Romance and Sex","HBO"]


//////////////////
// WEBPACK FOOTER
// ./src/content/projects/2019/NED-0534-got-show-matcher/themes.json
// module id = VqVp
// module chunks = 0